module.exports = __webpack_public_path__ + "static/media/test1_3.b61780f1.png";